export default {
  Normal: 1,
  Thousand: 2,
  Million: 3,
  Billion: 4,
};
